// import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
// import { AxiosInterceptor } from './app/interceptors/axios.interceptors';
import './index.css';
import 'nprogress/nprogress.css';

import App from './App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { createRoot } from 'react-dom/client';

//AxiosInterceptor();

// ReactDOM.render(
//   <HelmetProvider>
//     <SidebarProvider>
//       <BrowserRouter>
//         <App/>
//       </BrowserRouter>
//     </SidebarProvider>
//   </HelmetProvider>,
//   document.getElementById('root')
// );

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
);

serviceWorker.unregister();
